var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var Freeze = require('../utils/freeze');

module.exports = {
  initialize: function () {
    this.__state = {} as any;
    this.on(actionTypes.DATA_LOADED, this.__loadData);
  },

  __loadData: function (payload) {
    if (_.isEmpty(payload.data.tagGroups)) {
      return;
    }

    _.each(payload.data.tagGroups, _.bind(function (tagGroup) {
      Freeze.deepFreeze(tagGroup);
      this.__state[tagGroup.id] = tagGroup;
    }, this));

    this.emitChange();
  },

  /**
   * @returns {Object.<TagGroup>}
   *        All known TagGroups.
   */
  getAll: function (): Record<string, TagGroup> {
    return Freeze.safeReference(this.__state);
  },

  /**
   * @param {string} id
   * @returns {TagGroup=}
   *        The TagGroup with the given id, if one exists.
   */
  getById: function (id:string): TagGroup {
    return Freeze.safeReference(this.__state[id]);
  },
};

